import { NgModule } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, RouterModule } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { IgnoreStatusOfflinePatterns } from '@next/core-lib/components';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { ProprietaryFertilizersOverviewModule } from './proprietary-fertilizers-overview/proprietary-fertilizers-overview.module';
import { SharedModule } from './shared/shared.module';
import { AppEffects } from './store/app.effects';
import { appReducer } from './store/app.reducer';

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    ProprietaryFertilizersOverviewModule,
    AgrWrapperSiteSidenavModule,
  ],
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),

    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),

    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrSettings(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),

    provideState('app', appReducer),
    provideEffects(AppEffects),
    {
      provide: IgnoreStatusOfflinePatterns,
      useValue: ['/arable-service/organisation/customerprogress'],
      multi: true,
    },
  ],
})
export class AppModule {}
